import {
	reConstructionMaterialCharacteristicConstants
}from "./constants"
import actions from "../../actions"

const initialState = {
	isSending : false,
	materials : [],
	changed   : null
}

export default function (state = initialState, action){
	switch (action.type){
		case reConstructionMaterialCharacteristicConstants.CLEAR:
			return {
				...state,
				materials : null,
				changed   : null,
				isSending : false
			}
		case reConstructionMaterialCharacteristicConstants.UpdateCharacteristics.REQUEST:
		case reConstructionMaterialCharacteristicConstants.GetMaterials.REQUEST:
		case reConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.REQUEST:
		case reConstructionMaterialCharacteristicConstants.GetFileCharacteristics.REQUEST:
			return {
				...state,
				isSending : true,
				changed   : null
			}

		case reConstructionMaterialCharacteristicConstants.UpdateCharacteristics.FAILURE:
		case reConstructionMaterialCharacteristicConstants.GetMaterials.FAILURE:
		case reConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.FAILURE:
		case reConstructionMaterialCharacteristicConstants.GetFileCharacteristics.FAILURE:
			return {
				...state,
				error     : action.payload,
				isSending : false,
				changed   : null
			}
		case reConstructionMaterialCharacteristicConstants.GetFileCharacteristics.SUCCESS:
			return {
				...state,
				isSending: false
			}
		case reConstructionMaterialCharacteristicConstants.GetMaterials.SUCCESS:
			return {
				...state,
				isSending : false,
				materials : action.payload.result
			}
		case reConstructionMaterialCharacteristicConstants.UpdateCharacteristics.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.update : null
			}
		case reConstructionMaterialCharacteristicConstants.UpdateFileCharacteristics.SUCCESS:
			return {
				...state,
				isSending : false,
				changed   : action.payload.result ? actions.download : null
			}
		default:
			return state
	}
}